<template>
  <iframe style="height:240px;border:none;width:100%" :src="trustpilotWidgetUrl"></iframe>
</template>

<script>
import { getAction } from '@/api/manage.js'
import awesomeSwiper from './awesomeSwiper.vue'
import { swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    awesomeSwiper,
    swiperSlide
  },
  data() {
    return {
      trustpilotWidgetUrl: 'https://www.shopvidi.com/trustpilot?templateId=54ad5defc6454f065c28af8b',
      colors: ['#000000', '#000000', '#000000'],
      items: [], // 评论卡片的数据
      transformX: 0, // 移动的位置
      container: null, //
      timer: 0,
      store: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 4,
        loopFillGroupWithBlank: true,
        loop: true
      },
      turnPages: true,
      pagination: false
    }
  },

  computed: {
    isMobile() {
      const isMob = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return isMob
    }
    // ObjStyle() {
    //   return {
    //     transform: `translateX(${this.transformX}px)`
    //   }
    // }
  },
  async created() {
    // 判断环境
    if (process.env.NODE_ENV === 'test') {
      this.trustpilotWidgetUrl = 'https://test-thalesmart-manage-ui2.hupofintech.com/trustpilot?templateId=54ad5defc6454f065c28af8b'
    } else if (process.env.NODE_ENV === 'staging') {
      this.trustpilotWidgetUrl = 'https://staging.shopvidi.com/trustpilot?templateId=54ad5defc6454f065c28af8b'
    } else if (process.env.NODE_ENV === 'development') {
      this.trustpilotWidgetUrl = 'http://localhost:8080/trustpilot?templateId=54ad5defc6454f065c28af8b'
    }
    if (this.isMobile) {
      this.store = {
        slidesPerView: 1,
        spaceBetween: 10,
        loopFillGroupWithBlank: false,
        loop: false
      }
      this.turnPages = false
      this.pagination = true
    }
    let { code, result } = await getAction('/v0.2/brands/reviews')
    if (code === 200) {
      this.items = [...result.records]
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   const container = this.$refs.commentsList
    //   const items = container.querySelectorAll('.card-list')
    //   let move = () => (this.transformX < -items[0].offsetWidth / 2 ? (this.transformX = 0) : (this.transformX += -1))
    //   this.timer = setInterval(move, 30)
    //   container.addEventListener('mouseover', () => clearInterval(this.timer))
    //   container.addEventListener('mouseout', () => (this.timer = setInterval(move, 30)))
    // })
  },

  beforeDestroy() {
    clearInterval(this.timer) // 在组件销毁前清除定时器
  },
  methods: {
    handleGotoBrand(n) {
      mixpanel.track('Home-CUSTOMER REVIEWS', {
        brand: n.brandName,
        url: `${window.location.origin}/brand${n.brandSeoUrl}`,
        content: n.orderReviewList[0]['content']
      })
      window.open(`${window.location.origin}/brand${n.brandSeoUrl}`, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.card-container {
  width: 95%;
  max-width: 1400px;
  margin:0 auto;
}
// .card-list {
//   display: flex;
//   gap: 0 20px;
//   position: absolute;
//   left: 0;
// }

/deep/ .el-rate__icon {
  font-size: 18px;
  margin-right: 1px;
}
/deep/ .el-rate {
  margin-right: 10px;
}
/deep/ .el-icon-star-off {
  font-size: 16px;
}
/deep/ .el-rate__text {
  margin-left: 12px;
}

.card-list:last-child {
  // margin-left: 20px;
}
.card {
  box-sizing: border-box;
  text-align: left;
  width: 318px !important;
  height: 271px;
  border: 1px solid rgba(255, 255, 255, 0.39);
  background-color: #fff;
  opacity: 1;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 10px 10px 6px 10px;
  font-size: 14px;
  cursor: pointer;
  .card-1 {
    height: 35px;
    box-sizing: border-box;
    display: flex;
    padding-top: 10px;
    .card-time {
      margin-left: 14px;
      font-size: 12px;
    }
  }
  .card-2 {
    width: 298px;
    height: 55px;
    box-sizing: border-box;
    font-family: Satoshi;
    font-weight: 500;
    line-height: 18px;
    color: #262613;
    opacity: 1;
    overflow: hidden;
    text-overflow: ellipsis; /* 超过三行时，在第三行中间显示省略号 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* 控制最大行数为三行 */
  }

  .evaluator {
    margin-top: 10px;
    height: 15px;
    font-family: Satoshi;
    font-weight: 400;
    line-height: 15px;
    color: #5d5d5d;
    opacity: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .card-4 {
    margin-top: 5px;
    height: 15px;
    font-family: Satoshi;
    font-weight: 400;
    line-height: 20px;
    color: #5d5d5d;
    opacity: 1;
  }
  .card-5 {
    margin-top: 10px;
    box-sizing: border-box;
    height: 76px;
    font-family: Satoshi;
    font-weight: 400;
    line-height: 20px;
    color: #5d5d5d;
    opacity: 1;
    display: flex;
    gap: 0 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f6f5f3;
    .card-imgs {
      box-sizing: border-box;
      width: 66px;
      height: 66px;
      border-radius: 3px;
    }
  }

  .card-6 {
    margin-top: 5px;
    height: 28px;

    display: flex;
    align-items: center;

    .card-the-avatars {
      box-sizing: border-box;
      width: 28px;
      height: 28px;
      background: rgba(0, 0, 0, 0);
      border: 1px solid #e1e1e1;
      opacity: 1;
      border-radius: 150px;
      margin-right: 10px;
    }
  }
}
@media screen and (max-width: 600px){
  .card {
    width: 100% !important;
  }
  .card-container {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/reviewsList.vue